import { connect, ConnectedProps } from "react-redux";

import { FavoritesEntryType } from "redmond";
import { History } from "history";
import { IStoreState } from "../../../reducers/types";
import {
  getAdultsCount,
  getChildren,
  getFromDate,
  getPetsCount,
  getUntilDate,
} from "../../search/reducer";
import { WishlistManagementModal } from "./component";

interface IStateProps {
  fromDate: Date | null;
  untilDate: Date | null;
  adultsCount: number;
  childrenCount: number[];
  petsCount: number;
}

interface IOwnProps {
  history: History;
  entryType?: FavoritesEntryType;
}

const mapStateToProps = (state: IStoreState): IStateProps => ({
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
  adultsCount: getAdultsCount(state),
  childrenCount: getChildren(state),
  petsCount: getPetsCount(state),
});

type IDispatchProps = object;

const mapDispatchToProps = {};

const mergeProps = (
  stateProps: IStateProps,
  dispatchProps: IDispatchProps,
  ownProps: IOwnProps
) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
});

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type WishlistManagementModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedWishlistManagementModal = connector(
  WishlistManagementModal
);
